"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
Math.trunc = Math.trunc || function (x) {
    if (isNaN(x)) {
        return NaN;
    }
    if (x > 0) {
        return Math.floor(x);
    }
    return Math.ceil(x);
};
var NumberExt = (function () {
    function NumberExt() {
    }
    NumberExt.reset = function () {
        NumberExt._formatters = {};
    };
    NumberExt.format = function (culture, value, format, type, round) {
        round = round || types_1.NumberFormatRoundType.Round;
        var result = '';
        switch (type) {
            case types_1.NumberFormatType.Number:
                result = NumberExt._format(culture, value, format, round);
                break;
            case types_1.NumberFormatType.Percent:
                value *= 100;
                result = NumberExt._format(culture, value, format, round);
                if (culture.percentSign !== '%')
                    result = result.replace('%', culture.percentSign);
                break;
            case types_1.NumberFormatType.Short:
                if (value >= NumberExt.SHORT_FORMAT_THERESHOLD) {
                    var shortValue = value;
                    var i = 0;
                    var l = culture.number.short.length;
                    while (i < l) {
                        i++;
                        shortValue /= 1000;
                        if (shortValue < NumberExt.SHORT_FORMAT_THERESHOLD) {
                            break;
                        }
                    }
                    i--;
                    if (culture.number.short[i] !== '0')
                        value = shortValue;
                    result = NumberExt._format(culture, value, format, round);
                    if (culture.number.short[i] !== '0')
                        result = culture.number.short[i].replace('0', result);
                }
                else
                    result = NumberExt._format(culture, value, format, round);
                break;
            default:
                throw 'Unsupported number format type';
        }
        return result;
    };
    NumberExt._decimalAdjust = function (type, value, exp) {
        if (typeof exp === 'undefined' || +exp === 0) {
            return Math[type](value);
        }
        value = +value;
        exp = +exp;
        if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
            return NaN;
        }
        var valueParts = value.toString().split('e');
        value = Math[type](+(valueParts[0] + 'e' + (valueParts[1] ? (+valueParts[1] - exp) : -exp)));
        valueParts = value.toString().split('e');
        return +(valueParts[0] + 'e' + (valueParts[1] ? (+valueParts[1] + exp) : exp));
    };
    NumberExt._format = function (culture, value, format, round) {
        var formatSettings = NumberExt._parseFormatter(culture, format);
        if (!formatSettings)
            return '';
        var settings = value < 0 ? formatSettings.negative : formatSettings.positive;
        value = Math.abs(value);
        if (settings.maxDecimals) {
            value = NumberExt._decimalAdjust(NumberExt._round[round], value, -settings.maxDecimals);
        }
        else if (typeof settings.minDecimals === 'undefined') {
            value = NumberExt._decimalAdjust(NumberExt._round[round], value, 0);
        }
        var valueString = value.toString();
        var valueParts = valueString.split('.');
        var integer = valueParts[0];
        var decimal = valueParts.length > 1 ? valueParts[1] : '';
        if (valueString.indexOf('e-') > 0) {
            var expDecimals = Number(valueString.split('e-')[1]);
            valueString = value.toFixed(expDecimals);
            valueParts = valueString.split('.');
            integer = valueParts[0];
            decimal = valueParts.length > 1 ? valueParts[1] : '';
        }
        if (settings.minDecimals && settings.minDecimals > 0) {
            var padd = decimal.length < settings.minDecimals ? settings.minDecimals - decimal.length : 0;
            if (padd > 0) {
                decimal += Array(padd + 1).join('0');
            }
        }
        if (decimal.length > 0) {
            decimal = culture.decimal + decimal;
            if (!settings.zeroDecimals && +integer == 0)
                integer = '';
        }
        if (settings.groupSize) {
            var groups = [];
            var index = integer.length;
            while (index > settings.groupSize) {
                groups.push(integer.slice(index - settings.groupSize, index));
                index -= settings.groupSize;
            }
            groups.push(integer.slice(0, index));
            groups.reverse();
            integer = groups.join(culture.group);
        }
        var result = settings.prefix + integer + decimal + settings.suffix;
        var digits = culture.digits;
        if (digits) {
            var asciiBase_1 = '0'.charCodeAt(0);
            result = result.split('').map(function (c) {
                var code = c.charCodeAt(0) - asciiBase_1;
                return code > -1 && code < 10 ? digits[c.charCodeAt(0) - asciiBase_1] : c;
            }).join('');
        }
        return result;
    };
    NumberExt._parseFormatter = function (culture, format) {
        if (format in NumberExt._formatters)
            return NumberExt._formatters[format];
        var parts = format.split(';');
        if (parts.length > 0) {
            var positiveFormat = parts[0];
            var negativeFormat = parts.length > 1 ? parts[1] : culture.minusSign + parts[0];
            var positive = NumberExt._parseFormatterPart(positiveFormat, true);
            var negative = NumberExt._parseFormatterPart(negativeFormat, false);
            if (!positive || !negative)
                return NumberExt._formatters[format] = null;
            return NumberExt._formatters[format] = {
                positive: positive,
                negative: negative,
            };
        }
        return NumberExt._formatters[format] = null;
    };
    NumberExt._parseFormatterPart = function (format, positive) {
        var numberRegex = /(#+,)?(#+0?)(\.0*#*)?/;
        var match = numberRegex.exec(format);
        if (!match || !match[2])
            return;
        var result = {
            prefix: format.substr(0, match.index),
            suffix: format.substr(match.index + match[0].length),
            zeroDecimals: false,
            positive: positive
        };
        if (match[1]) {
            result.groupSize = match[2].length;
        }
        if (match[2][match[2].length - 1] == '0')
            result.zeroDecimals = true;
        if (match[3]) {
            if (match[3].length == 1) {
                result.minDecimals = 0;
            }
            else {
                result.maxDecimals = match[3].length - 1;
                var lastZeroIndex = match[3].lastIndexOf('0');
                if (lastZeroIndex > -1)
                    result.minDecimals = lastZeroIndex;
            }
        }
        return result;
    };
    NumberExt.parse = function (culture, value, formats) {
        var digits = culture.digits;
        if (digits) {
            var asciiBase_2 = digits.charCodeAt(0);
            value = value.split('').map(function (c) {
                var code = c.charCodeAt(0) - asciiBase_2;
                return code > -1 && code < 10 ? code.toString() : c;
            }).join('');
        }
        if (formats && formats.length > 0) {
            for (var i = 0, l = formats.length; i < l; i++) {
                var format = formats[i];
                var result = NumberExt._parseExact(culture, value, format);
                if (!isNaN(result)) {
                    if (value.indexOf(culture.percentSign) > -1)
                        result /= 100;
                    return result;
                }
            }
        }
        else {
            var result = NumberExt._parseExact(culture, value, culture.number.decimal);
            if (isNaN(result)) {
                result = NumberExt._parseExact(culture, value, culture.number.percent);
                if (!isNaN(result))
                    result /= 100;
            }
            return result;
        }
        return NaN;
    };
    NumberExt._parseExact = function (culture, value, format) {
        var setting = NumberExt._parseFormatter(culture, format);
        if (setting) {
            if (!setting.positive.parser)
                setting.positive.parser = NumberExt._creteParser(culture, setting.positive);
            var positive = true;
            var match = setting.positive.parser.exec(value);
            if (!match) {
                positive = false;
                if (!setting.negative.parser)
                    setting.negative.parser = NumberExt._creteParser(culture, setting.negative);
                match = setting.negative.parser.exec(value);
            }
            if (match) {
                var integer = match[2].split(culture.group).join('');
                var decimal = match[3] ? match[3].substr(1) : '0';
                var parseValue = integer + '.' + decimal;
                var result = parseFloat(parseValue);
                result = positive ? result : -result;
                return result;
            }
        }
        return NaN;
    };
    NumberExt._creteParser = function (culture, format) {
        var unicode = function (v) {
            v = v.charCodeAt(0).toString(16);
            var x = v.length < 4 ? 4 - v.length : 0;
            if (x > 0) {
                v = Array(x + 1).join('0') + v;
            }
            return '\\u' + v;
        };
        var escape = function (v) {
            return v.replace(/([\^\$\.\*\+\?\|\[\]\(\)\{\}])/g, "\\\\$1");
        };
        var parserExpression = ['^(', escape(format.prefix), ')([\\d', unicode(culture.group), ']*)(', unicode(culture.decimal), '\\d+)?(', escape(format.suffix), ')$'];
        return new RegExp(parserExpression.join(''));
    };
    NumberExt._formatters = {};
    NumberExt.SHORT_FORMAT_THERESHOLD = 1000;
    NumberExt._round = ['round', 'ceil', 'floor', 'trunc'];
    return NumberExt;
}());
exports.NumberExt = NumberExt;
//# sourceMappingURL=number-ext.js.map


//////////////////
// WEBPACK FOOTER
// ../player-globalization/number-ext.js
// module id = 257
// module chunks = 0 1